import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from '@saucelabs/ds-breadcrumbs';

const PerformanceNav = ({ testId, isOnHistoryPage, pageIndex, routerSearchQuery }) => {
  const crumbsList = [{
    name: 'Test Details',
    url: {
      pathname: `/tests/${testId}`,
      search: routerSearchQuery,
    },
  }, {
    name: 'Performance Report',
    url: {
      pathname: `/performance/${testId}/${pageIndex}`,
      search: routerSearchQuery,
    },
  },
  {
    name: 'Performance History',
    url: {
      pathname: `/performance/${testId}/${pageIndex}/history`,
      search: routerSearchQuery,
    },
  }];

  return (
    <Breadcrumbs list={isOnHistoryPage ? crumbsList : crumbsList.slice(0, 2)} />
  );
};

PerformanceNav.propTypes = {
  isOnHistoryPage: PropTypes.bool.isRequired,
  pageIndex: PropTypes.number.isRequired,
  routerSearchQuery: PropTypes.string,
  testId: PropTypes.string.isRequired,
};

PerformanceNav.defaultProps = {
  routerSearchQuery: '',
};

export default PerformanceNav;
